import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import BetLink from 'modules/Common/containers/BetLink';
import { getSkyRef, racecardResultHref } from 'modules/HorseRacing/utils';
import Image from 'modules/Common/components/Image';
import Stars from './Stars';
import Silk from 'modules/Common/components/Silk';
import moment from 'moment';

require('./RacingTip.scss');

const SKYBET_URL = "https://m.skybet.com";

const generateBetLink = (rideStatus = null, ride_reference = {}, currentOdds = 'SP', raceId = null, onOddsClick) => {
  const canBetlink = (rideStatus && rideStatus === 'RUNNER' && raceId && ride_reference.external_reference !== null);

  return canBetlink ?
    (<span onClick={onOddsClick}>
      <BetLink className="tip__odds-link" forceLinkOut={true} eventId={raceId} betId={getSkyRef(ride_reference)} odds={currentOdds}>{currentOdds}</BetLink>
    </span>)
    :
    <a onClick={onOddsClick} href={SKYBET_URL} className="tip__odds-link" target="_blank">SP</a>
}

function getRaceTime(tipDateTime) {
  const raceMoment = moment(tipDateTime);

  return raceMoment.format("HH:mm");
}

const RacingTip = ({ tip, ride, onRaceCardLinkClick, onOddsClick, imageSet, isLarge }) => {
  if (!ride || !tip) {
    return null;
  }

  const {
    betting: { current_odds: currentOdds = 'SP' },
    ride_status: rideStatus,
    ride_reference: rideReference,
    raceData,
    silk_filename
  } = ride;

  const skybetLink = generateBetLink(rideStatus, rideReference, currentOdds, raceData.race_skybetId, onOddsClick);
  const tipCssClasses = ['tip'];
  let imageType = 'tipWidget';
  let imageRatio = 1.9;
  if (isLarge) {
    tipCssClasses.push('large-tip');
    imageType = 'tipWidgetLarge';
    imageRatio = 1.0;
  }

  let advisedAt;
  if (tip.use_starting_price) {
    advisedAt = "Advised at SP";
  } else if (tip.tipped_at_numerator && tip.tipped_at_denominator) {
   advisedAt = `Advised at ${tip.tipped_at_numerator}/${tip.tipped_at_denominator}`;
  }
  else {
    advisedAt = "";
  }

  return (
   <div className={tipCssClasses.join(' ')}>
     <div className="tip__image">
         <Image imageMedia={imageSet} imageType={imageType} ratio={imageRatio} />
     </div>
     <div className="tip__content">
      <div className="tip__info">
        <div className="tip__selection">
          <Link onClick={onRaceCardLinkClick} to={`${racecardResultHref(raceData)}#${rideReference.id}`}>
            <div className="tip__silk">
              <Silk filename={silk_filename} />
            </div>
            <div className="tip__description">
              <div className="tip__horse">{tip.selection}</div>
              <div className="tip__course">{`${getRaceTime(tip.tip_date)} • ${tip.course}`}</div>
            </div>
          </Link>
        </div>
        <div className="tip__stake-odds">
          <Stars points={tip.points} />
          <span className="tip__stake">{` • ${tip.points}${tip.points == 1 ? 'pt' : 'pts'}, ${tip.bet_type} • `}</span>
          <span className="tip__advised-odds">{advisedAt}</span>
        </div>
        <div className="tip__summary">{tip.summary}</div>      
      </div>
      <div className="tip__footer">
            Odds provided by <a onClick={onOddsClick} href={SKYBET_URL}><img src="/img/masthead/skybet-dec2017.png" /></a>
            {
              skybetLink
            }
        </div>
     </div>
   </div>);
};

RacingTip.propTypes = {
  tip: PropTypes.object.isRequired,
  ride: PropTypes.object,
  onRaceCardLinkClick: PropTypes.func,
  onOddsClick: PropTypes.func,
  imageSet: PropTypes.object,
  isLarge: PropTypes.bool
};

export default RacingTip;



// WEBPACK FOOTER //
// ./modules/Common/components/TipsWidget/components/RacingTip.js